import Swiper from 'swiper';
import { Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/scss';

export default function (element, data) {
    element.swiper = new Swiper(element.querySelector(".swiper"), {
        slidesPerView: 'auto',
        modules: [Mousewheel, Pagination],
        mousewheel: true,
        spaceBetween: 3,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },

    });
};

// @widgetLoadingMode:lazy-once
